import { render, staticRenderFns } from "./auth-app.vue?vue&type=template&id=5fc9b223"
import script from "./auth-app.vue?vue&type=script&lang=js"
export * from "./auth-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fc9b223')) {
      api.createRecord('5fc9b223', component.options)
    } else {
      api.reload('5fc9b223', component.options)
    }
    module.hot.accept("./auth-app.vue?vue&type=template&id=5fc9b223", function () {
      api.rerender('5fc9b223', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/main/components/auth-app.vue"
export default component.exports